/*
 * Wishlist heart toggle on product cards (Step 5b)
 * Button is a direct child of .card-wrapper (outside the card link's
 * stacking context), so a plain click binds reliably. Relies on
 * window.Wishlist (wishlist.js).
 */
(function () {
  'use strict';

  function setState(btn, saved) {
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!window.Wishlist) return;
    var id = this.getAttribute('data-product-id');
    var url = this.getAttribute('data-product-url') || '';
    setState(this, window.Wishlist.toggle(id, url));
  }

  function bind(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('[data-wishlist-toggle]:not([data-wishlist-bound])');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('data-wishlist-bound', 'true');
      btns[i].addEventListener('click', onClick);
      if (window.Wishlist) {
        setState(btns[i], window.Wishlist.has(btns[i].getAttribute('data-product-id')));
      }
    }
  }

  function syncAll() {
    if (!window.Wishlist) return;
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      setState(btns[i], window.Wishlist.has(btns[i].getAttribute('data-product-id')));
    }
  }

  document.addEventListener('wishlist:changed', syncAll);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
})();
